import { getParameterByName } from "../../../utils/urlParser";
import { smsLoginInitialState } from "./smslogin.types";

const returnUrl = getParameterByName("returnUrl");
const passedUsername = decodeURIComponent(getParameterByName("username"));

export const initialState: smsLoginInitialState = {
	isFetching: false,
	alerts: [],
	form: {
		mobilePhone: "",
		email: passedUsername,
		returnUrl,
	},
};
